import {PixiComponent} from '@inlet/react-pixi';
import {Graphics} from 'pixi.js';

export type TriangleProps = {
    x?: number;
    y?: number;
    width: number;
    fill: number;
};

export const Triangle = PixiComponent<TriangleProps, Graphics>('Triangle', {
    create: () => {
        const graphics = new Graphics();

        graphics.name = 'Triangle';

        return graphics;
    },

    applyProps: (instance, oldP, props) => {
        const { x = 0, y = 0, width, fill} = props;
        const hight = width;
        const halfway = width / 2;

        instance.position.set(x, y);

        // draw triangle
        instance.beginFill(fill, 1);
        instance.moveTo(width, 0);
        instance.lineTo(halfway, hight);
        instance.lineTo(0, 0);
        instance.lineTo(halfway, 0);
        instance.endFill();
    }
});